export const generateMappingTemplate = [
    {
        fieldGroupClassName: "row",
        fieldGroup: [
            {
                className: "col-md-6",
                key: "LLM",
                type: "select",
                templateOptions: {
                    label: "LLM (Embedding)",
                    placeholder: 'Select an option',
                    required: true,
                    options: [
                        {
                            label: 'GPT 4.1',
                            value: 'gpt_4.1'
                        },
                        {
                            label: 'GPT 4.2',
                            value: 'gpt_4.2'
                        }
                    ]
                },
                validation: {
                    messages: {
                      required: () => "This field is required."
                    }
                }
            },
            {
                className: "col-md-6",
                key: "embeddingModel",
                type: "select",
                defaultValue: 'openai-text-embedding-3-small',
                templateOptions: {
                    label: "Embedding Model",
                    required: true,
                    options: [
                        {
                            label: "OpenAI-text-embedding-3-small",
                            value: "openai-text-embedding-3-small",
                        }
                    ]
                },
                hideExpression: true,
                validation: {
                    messages: {
                      required: () => "This field is required."
                    }
                }
            },
            {
                className: "col-md-6",
                key: "vectorDatabase",
                type: "select",
                templateOptions: {
                    label: "Vector Database",
                    required: true,
                    options: [
                        {
                            label: "Pinecone",
                            value: "pinecone",
                        }
                    ]
                },
                validation: {
                    messages: {
                      required: () => "This field is required."
                    }
                }
            },
            {
                className: "col-md-6",
                key: "vectorStoreApiKey",
                type: "input",
                templateOptions: {
                    label: "Vector Database API Key",
                    type: "password",
                    required: true
                },
                validation: {
                    messages: {
                      required: () => "This field is required."
                    }
                }
            },
            {
                className: "col-md-6",
                key: "githubLink",
                type: "input",
                templateOptions: {
                    label: "GitHub Repo Link",
                    required: true
                },
                validation: {
                    messages: {
                      required: () => "This field is required."
                    }
                }
            },
            {
                className: "col-md-6",
                key: "githubToken",
                type: "input",
                templateOptions: {
                    label: "GitHub Token",
                    type: "password",
                    required: true
                },
                validation: {
                    messages: {
                      required: () => "This field is required."
                    }
                }
            }
        ]
    }
];

export const generateMappingTemplateEdit = [
    {
        fieldGroupClassName: "row",
        fieldGroup: [
            {
                className: "col-md-6",
                key: "LLM",
                type: "select",
                defaultValue: 'gpt_4.1',
                templateOptions: {
                    disabled: true,
                    label: "LLM (Embedding)",
                    required: true,
                    options: [
                        {
                            label: 'GPT 4.1',
                            value: 'gpt_4.1'
                        },
                        {
                            label: 'GPT 4.2',
                            value: 'gpt_4.2'
                        }
                    ]
                },
                validation: {
                    messages: {
                      required: () => "This field is required."
                    }
                }
            },
            {
                className: "col-md-6",
                key: "embeddingModel",
                type: "select",
                defaultValue: 'openai-text-embedding-3-small',
                templateOptions: {
                    disabled: true,
                    label: "Embedding Model",
                    required: true,
                    options: [
                        {
                            label: "OpenAI-text-embedding-3-small",
                            value: "openai-text-embedding-3-small",
                        }
                    ]
                },
                hideExpression: true,
                validation: {
                    messages: {
                      required: () => "This field is required."
                    }
                }
            },
            {
                className: "col-md-6",
                key: "vectorDatabase",
                type: "select",
                templateOptions: {
                    disabled: true,
                    label: "Vector Database",
                    required: true,
                    options: [
                        {
                            label: "Pinecone",
                            value: "pinecone",
                        }
                    ]
                },
                validation: {
                    messages: {
                      required: () => "This field is required."
                    }
                }
            },
            {
                className: "col-md-6",
                key: "vectorStoreApiKey",
                type: "input",
                templateOptions: {
                    disabled: true,
                    label: "Vector Database API Key",
                    required: true,
                    type: "password",
                },
                validation: {
                    messages: {
                      required: () => "This field is required."
                    }
                }
            },
            {
                className: "col-md-6",
                key: "githubLink",
                type: "input",
                templateOptions: {
                    disabled: true,
                    label: "GitHub Repo Link",
                    required: true
                },
                validation: {
                    messages: {
                      required: () => "This field is required."
                    }
                }
            },
            {
                className: "col-md-6",
                key: "githubToken",
                type: "input",
                templateOptions: {
                    disabled: true,
                    label: "GitHub Token",
                    required: true,
                    type: "password",
                },
                validation: {
                    messages: {
                      required: () => "This field is required."
                    }
                }
            }
        ]
    }
];

export const generateMappingTemplateImpacted = [
    {
        fieldGroupClassName: "row",
        fieldGroup: [
            {
                className: "col-md-12",
                key: "name",
                type: "input",
                templateOptions: {
                    disabled: true,
                    label: "Mapping Name",
                    required: true
                },
                validation: {
                    messages: {
                      required: () => "This field is required."
                    }
                }
            },
            {
                className: "col-md-12",
                key: "LLM (Embedding)",
                type: "select",
                defaultValue: 'gpt_4.1',
                templateOptions: {
                    disabled: true,
                    label: "LLM",
                    required: true,
                    options: [
                        {
                            label: 'GPT 4.1',
                            value: 'gpt_4.1'
                        },
                        {
                            label: 'GPT 4.2',
                            value: 'gpt_4.2'
                        }
                    ]
                },
                validation: {
                    messages: {
                      required: () => "This field is required."
                    }
                }
            },
            {
                className: "col-md-12",
                key: "embeddingModel",
                type: "select",
                defaultValue: 'openai-text-embedding-3-small',
                templateOptions: {
                    disabled: true,
                    label: "Embedding Model",
                    required: true,
                    options: [
                        {
                            label: "OpenAI-text-embedding-3-small",
                            value: "openai-text-embedding-3-small",
                        }
                    ]
                },
                hideExpression: true,
                validation: {
                    messages: {
                      required: () => "This field is required."
                    }
                }
            },
            {
                className: "col-md-12",
                key: "vectorDatabase",
                type: "select",
                templateOptions: {
                    disabled: true,
                    label: "Vector Database",
                    required: true,
                    options: [
                        {
                            label: "Pinecone",
                            value: "pinecone",
                        }
                    ]
                },
                validation: {
                    messages: {
                      required: () => "This field is required."
                    }
                }
            },
            {
                className: "col-md-12",
                key: "vectorStoreApiKey",
                type: "input",
                templateOptions: {
                    disabled: true,
                    label: "Vector Database API Key",
                    required: true,
                    type: "password",
                },
                validation: {
                    messages: {
                      required: () => "This field is required."
                    }
                }
            },
            {
                className: "col-md-12",
                key: "githubToken",
                type: "input",
                templateOptions: {
                    disabled: true,
                    label: "GitHub Token",
                    required: true,
                    type: "password",
                },
                validation: {
                    messages: {
                      required: () => "This field is required."
                    }
                }
            },
            {
                className: "col-md-12",
                key: "githubLink",
                type: "input",
                templateOptions: {
                    disabled: false,
                    label: "GitHub Repo Link",
                    required: true
                },
                validation: {
                    messages: {
                      required: () => "This field is required."
                    }
                }
            }
        ]
    }
];